import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { bind } from '../Utils/Bind';

export class NotificationHandle {
    @bind
    @action
    public close() {
        this.isOpen = false;
    }

    @bind
    @action
    public onToggle() {
        this.isOpen = !this.isOpen;
    }

    @bind
    @action
    public set(
        color: 'teal' | 'info' | 'success' | 'danger' | 'warning',
        message: React.ReactNode,
        timeout?: number,
        hideClose?: boolean
    ) {
        if (this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
        }

        this.hideClose = hideClose;

        if (timeout) {
            this.timeoutHandle = window.setTimeout(this.close, timeout);
        }

        this.color = color;
        this.message = message;
        this.isOpen = true;
    }

    @bind
    public setError(error: any) {
        this.set('danger', error.message, 10000);
    }

    @observable
    public isOpen = false;

    @observable
    public message: React.ReactNode = 'This is a test of the notification system.';

    @observable
    public color: 'teal' | 'info' | 'success' | 'danger' | 'warning' = 'info';

    @observable
    public hideClose?: boolean = false;

    private timeoutHandle?: number;
}

export interface INotificationAlertProps {
    readonly className?: string;
    readonly notificationHandle: NotificationHandle;
}

@observer
export class NotificationAlert extends React.Component<INotificationAlertProps> {
    public render() {
        return <div>{this.renderAlert()}</div>;
    }

    @bind
    private renderAlert() {
        if (this.props.notificationHandle.isOpen) {
            return (
                <div
                    className={
                        this.props.className +
                        ' notification-alert text-center p-2 text-white bg-' +
                        this.props.notificationHandle.color
                    }
                >
                    <div className="m-0 d-inline-block p-2">{this.props.notificationHandle.message}</div>
                    {!this.props.notificationHandle.hideClose && (
                        <a className="btn btn-link float-end" onClick={this.props.notificationHandle.close}>
                            <BsXCircle color="white" />
                        </a>
                    )}
                </div>
            );
        }
    }
}
